<h1 mat-dialog-title>Assigner un chauffeur</h1>
<div mat-dialog-content>
  <form [formGroup]="driverForm" class="form">
    <mat-form-field class="drivers-field">
      <mat-label>Assigner un chauffeur</mat-label>
      <mat-select formControlName="driver">
        <mat-option *ngFor="let driver of data.drivers" [value]="driver">
          {{driver.username}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Commentaire pour le chauffeur</mat-label>
      <textarea matInput rows="3" formControlName="comment"></textarea>
    </mat-form-field>

    <div class="actions">
      <button class="driverButton" mat-raised-button color="primary" type="button" (click)="confirmDriverChange()"
        [disabled]="driverForm.pristine">Valider</button>
      <button class="driverButton" mat-raised-button color="primary" type="button"
        (click)="onNoClick()">Annuler</button>
    </div>

  </form>
</div>
<div mat-dialog-actions>
  <!-- <button mat-button cdkFocusInitial>Valider</button> -->
</div>